export default "__VITE_ASSET__c57dde0e__"